export class LesionSurface {
  private static _values: LesionSurface[] = [];
  private static _lookup: Map<number, LesionSurface> = new Map();

  static fromId(id: number) {
    const instance = LesionSurface._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid LesionSurface.id: ' + id);
    }
    return instance;
  }

  static values(): LesionSurface[] {
    return [...LesionSurface._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    LesionSurface._values.push(this);
    LesionSurface._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<LesionSurface: ' + this.id + ", label='" + this.label + "'>";
  }
}
